import { Component, HostBinding, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UserPrincipalService } from '@app-core/providers/user-principal.service';
import { PaymentDialogComponent } from '@shared/components/payment-dialog/payment-dialog.component';

@Component({
  selector: 'app-payment-btn',
  templateUrl: './payment-btn.component.html',
  styleUrls: ['./payment-btn.component.scss']
})
export class PaymentBtnComponent {

  private _placement: 'desktop' | 'mobile';

  @Input()
  public set placement (opt: 'desktop' | 'mobile') {
    this._placement = opt;
  }

  @HostBinding('class.desktop')
  private get isDesktop() {
    return this._placement === 'desktop';
  }

  @HostBinding('class.mobile')
  private get isMobile() {
    return this._placement === 'mobile';
  }

  constructor(private dialog: MatDialog,
              private userPrincipal: UserPrincipalService) {}

  public get balance() {
    return this.userPrincipal.userBalance;
  }

  public showPaymentPopup() {
    this.dialog
      .open(PaymentDialogComponent)
      .beforeClosed()
      .subscribe(res => {
        if (res) {
          this.userPrincipal.fetchBalance();
        }
      });
  }

}
